import { downloadFromLink } from '@/modules/upload/cloud/downloadFromLink'
import { CLOUD_FILE_SIZE_LIMIT_BYTES } from '@/modules/upload/cloud/sizeLimit'
import type { CloudSource, PickedCloudFile } from '@/modules/upload/cloud/types'
import type { DropboxChooser, DropboxChooserFile } from './dropins'

const toPickedFile = ({
  name,
  bytes,
  link,
}: DropboxChooserFile): PickedCloudFile => ({
  name,
  size: bytes,
  download: () => downloadFromLink(link),
})

// Dropbox calls cancel when the customer closes the chooser; that picks nothing.
const chooseFiles = (chooser: DropboxChooser) =>
  new Promise<PickedCloudFile[]>((resolve) =>
    chooser.choose({
      success: (files) => resolve(files.map(toPickedFile)),
      cancel: () => resolve([]),
      linkType: 'direct',
      multiselect: true,
      extensions: ['.pdf'],
      sizeLimit: CLOUD_FILE_SIZE_LIMIT_BYTES,
    }),
  )

const loadedChooser = () => {
  if (!window.Dropbox) throw new Error('Dropbox Chooser is not loaded')
  return window.Dropbox
}

export const createDropboxSource = (
  appKey: string | undefined,
): CloudSource => ({
  label: 'Dropbox',
  blockedLinkAdvice:
    'Your Dropbox team may block outside links. Download it and drop it here.',
  isAvailable: () =>
    Boolean(appKey) && Boolean(window.Dropbox?.isBrowserSupported()),
  pick: () => chooseFiles(loadedChooser()),
})
